var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-grid-search-floating-filter",on:{"click":_vm.showFilter}},[_c('input',{staticClass:"ag-floating-filter-input",attrs:{"type":"text","readonly":"","placeholder":_vm.placeholder,"title":_vm.label},domProps:{"value":_vm.label}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce43ee0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SigmaClientNew/AgGridSearchFloatingFilter.vue
// module id = kH6q
// module chunks = 1